module.exports = __webpack_public_path__ + "assets/img/font7.8fb4b376.png";